export default "__VITE_PUBLIC_ASSET__4395cf49__"